import styled from 'styled-components';

export const Term = styled.div`
  color: #004e93;
  font-size: 20px;
  font-weight: bold;  
`;
